module.exports = __webpack_public_path__ + "static/media/kmg-kalibrierung_Web_DE.4cb7c978.jpg";